import { render } from "./FileManagement.vue?vue&type=template&id=561133c4&scoped=true"
import script from "./FileManagement.vue?vue&type=script&lang=js"
export * from "./FileManagement.vue?vue&type=script&lang=js"

import "./FileManagement.vue?vue&type=style&index=0&id=561133c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-561133c4"]])

export default __exports__